import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { ItemPane } from 'page/StandInferenceScreen/ItemPane'
import { store } from 'store/store'

export const ItemsPane = observer(() => {
  const { carousel, extend } = store.carousel
  const items = carousel.item?.items ?? []
  const many = items.length > 1

  return <Vertical gap={12} spring>
    {!extend && items.map((item, index) => (
      <ItemPane key={index} item={item} many={many} />
    ))}
    {extend && <ItemPane item={extend} many={many} full />}
  </Vertical>
})
